import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'next-i18next';
import { scroller } from 'react-scroll';
import config from 'src/config';

import FindTrainingCourseSectionStyle from './style';

const FindTrainingCourseSection = ({ profileCPD }: { profileCPD: boolean }) => {
  const { t } = useTranslation('common');

  const handleScrollToTop = () => {
    scroller.scrollTo(profileCPD ? 'cpdRecommandSection' : 'cpdBoxSearchRecommand', {
      duration: 1000,
      smooth: true,
      offset: profileCPD ? -20 : 0,
    });
  };

  return (
    <FindTrainingCourseSectionStyle
      backgroundImage={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/BGFinalSection-CPD.png`}
    >
      <Box className="container">
        <Typography color="#fff" variant="h1" className="topic">
          {t('cpd_landing.find.training.course.title')}
        </Typography>
        <Typography color="#fff" variant="subtitle2" sx={{ width: 300, margin: 'auto' }}>
          {t('cpd_landing.find.training.course.content')}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          sx={{ my: 3 }}
          className="search-tranining-course-button"
          onClick={handleScrollToTop}
        >
          {t('cpd.common.explore.training.course')}
        </Button>
      </Box>
    </FindTrainingCourseSectionStyle>
  );
};

export default FindTrainingCourseSection;
